import { useMemo } from "react";
import useSWR, { mutate } from "swr";
import { fetcherPost, fetcher, fetcherDelete, fetcherPut } from "../utils/axios";

const endpoints = {
    key: '/groups',
    create: '/group',
    customers: '/customers',
    customer: '/customer'
}

export async function fetchGroups(args) {
    const data = await fetcher(args);
    return data?.data;
}

export function useGetGroups(skip = false) {
    const { data, isLoading, error, isValidating, mutate } = useSWR(skip ? null : endpoints.key, fetchGroups, {
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        errorRetryCount: 0
    });
    const memoizedValue = useMemo(() => {
        return {
            groups: data || [],
            isGroupsLoading: isLoading,
            groupsError: error,
            isGroupsValidating: isValidating,
            isGroupsEmpty: !isLoading && !data?.length,
            mutateGroups: mutate
        }
    }, [data, error, isLoading, isValidating]);

    return memoizedValue;
}

export async function createGroup(payload) {
    const data = await fetcherPost([endpoints.create, payload]);
    mutate(endpoints.key);
    return data?.data;
}

export async function updateGroup(groupId, payload) {
    const data = await fetcherPut([endpoints.create + `/${groupId}`, payload]);
    mutate(endpoints.key);
    return data?.data;
}

export async function fetchGroupCustomers(args) {
    const data = await fetcher(args);
    return data?.data || [];
    // else throw new Error(data?.error || 'Failed to get group customers');
}

export function useGetGroupCustomers(groupId) {
    const { data, isLoading, error, isValidating, mutate } = useSWR(
        groupId ? `${endpoints.create}/${groupId}${endpoints.customers}` : null, fetchGroupCustomers, {
        revalidateIfStale: true,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        errorRetryCount: 0
    }
    );
    const memoizedValue = useMemo(() => {
        return {
            customers: data || [],
            isCustomersLoading: isLoading,
            customersError: error,
            isCustomersValidating: isValidating,
            isCustomersEmpty: !isLoading && !data?.length,
            mutateCustomers: mutate
        }
    }, [data, error, isLoading, isValidating]);

    return memoizedValue;
}


export async function deleteGroup(groupId) {
    await fetcherDelete([endpoints.create + `/${groupId}`]);
    mutate(endpoints.key);
}

export async function deleteCustomerFromGroup(customerId, groupId) {
    await fetcherDelete([endpoints.customer + `/${customerId}/group/${groupId}`]);
    mutate(endpoints.key);
}
